<template>
  <Admin id="setting">
    <v-main>
      <v-container fluid v-if="!isProductListLoading">
        <v-row align="center" justify="center">
          <v-col cols="12">

            <!-- ==================== BASE MENUS ==================== -->

            <SettingButton
              iconSrc="/images/icons/icon-setting-board.svg"
              altText="board"
              label="ปรับแต่งบอร์ด"
              :to="{ name: 'Company.Settings.Board' }"
              :isDisabled="selectedCompany.isDemo"
            />

            <SettingButton
              v-if="role.owner || isDevOrEngineer"
              iconSrc="/images/icons/icon-setting-users.svg"
              altText="users"
              label="ผู้ใช้งาน"
              :to="{ name: 'Company.Settings.Users' }"
              :isDisabled="selectedCompany.isDemo"
            />

            <SettingButton
              v-if="role.owner || isDevOrEngineer"
              iconSrc="/images/icons/icon-setting-company.svg"
              altText="companies"
              label="โปรไฟล์บริษัท"
              :to="{ name: 'Company.Settings.Company' }"
              :isDisabled="selectedCompany.isDemo"
            />

            <!-- ==================== ETAX MENUS ==================== -->

            <template v-if="showEtaxMenus">
              <SettingButton
                iconSrc="/images/icons/icon-setting-payments.svg"
                altText="payments"
                label="การชำระเงิน"
                :to="{ name: 'Company.Settings.Payments' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <SettingButton
                iconSrc="/images/icons/icon-setting-keys.svg"
                altText="keys"
                label="หนังสือรับรอง"
                :to="{ name: 'Company.Settings.Keys' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <SettingButton
                iconSrc="/images/icons/icon-setting-erps.svg"
                altText="erp"
                label="โปรแกรมบัญชี"
                :to="{ name: 'Company.Settings.Erp' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <SettingButton
                iconSrc="/images/icons/icon_menu_ecommerce.svg"
                altText="shops"
                label="จัดการใบสั่งขายออนไลน์"
                :to="{ name: 'Company.Settings.Shops' }"
                :isDisabled="selectedCompany.isDemo"
                labelFontSize="13px"
              />

              <SettingButton
                iconSrc="/images/icons/icon_email_config.svg"
                altText="email"
                label="อีเมล"
                :to="{ name: 'Company.Settings.Email' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <SettingButton
                iconSrc="/images/icons/currency-exchange-repairer.svg"
                altText="kbank"
                label="KBank"
                :to="{ name: 'Company.Settings.KBank' }"
                :isDisabled="selectedCompany.isDemo"
              />
            </template>

            <!-- ==================== PDF DOC MENU ==================== -->

            <template v-if="product.isPdfDoc && isDevOrEngineer">
              <SettingButton
                iconSrc="/images/icons/icon_auto_doc.svg"
                altText="autoDocument"
                label="เอกสารอัตโนมัติ"
                :to="{ name: 'Company.Settings.AutoDoc' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <SettingButton
                iconSrc="/images/icons/icon-setting-test.svg"
                altText="testAR"
                label="ทดสอบ AR"
                :to="{ name: 'Company.Settings.TestDoc' }"
                :isDisabled="selectedCompany.isDemo"
              />
            </template>

            <!-- ==================== AP AUTOMATE ==================== -->

            <template v-if="product.isApAutomate">
              <SettingButton
                iconSrc="/images/icons/icon-setting-ai-master-data.svg"
                altText="masterData"
                label="ข้อมูลพื้นฐาน"
                :to="{ name: 'Company.Settings.ApAutomationMaster' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <SettingButton
                iconSrc="/images/icons/icon-setting-ai-ap.svg"
                altText="vendor"
                label="ผู้จำหน่าย"
                :to="{ name: 'Company.Settings.ApAutomation' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <template v-if="isDevOrEngineer">
                <SettingButton
                  iconSrc="/images/icons/icon_auto_doc.svg"
                  altText="apAutoDoc"
                  label="เอกสารอัตโนมัติ AP"
                  :to="{ name: 'Company.Settings.ApAutomationPrompt' }"
                  :isDisabled="selectedCompany.isDemo"
                />

                <SettingButton
                  iconSrc="/images/icons/icon-setting-test-ap.svg"
                  altText="testAP"
                  label="ทดสอบAP"
                  :to="{ name: 'Company.Settings.TestDoc-AP' }"
                  :isDisabled="selectedCompany.isDemo"
                />
              </template>
            </template>

            <!-- ==================== WHT ==================== -->

            <SettingButton
              v-if="product.isNsThaiSmartTax"
              iconSrc="/images/icons/wht-setting.svg"
              altText="wht"
              label="ตั้งค่าภาษีหัก ณ ที่จ่าย"
              :to="{ name: 'Company.Settings.Wht' }"
              :isDisabled="selectedCompany.isDemo"
              labelFontSize="13px"
            />

            <!-- ==================== FIXED ASSET COUNT ==================== -->

            <SettingButton
              v-if="product.isFixedAssetCount && (role.owner || isDevOrEngineer)"
              iconSrc="/images/icons/dep-setting.svg"
              altText="department"
              label="Department Settings"
              :to="{ name: 'Company.Settings.Department' }"
              :isDisabled="selectedCompany.isDemo"
              labelFontSize="13px"
            />

            <!-- ==================== EXCHANGE RATE ==================== -->

            <template v-if="product.isExchangeRate">
              <SettingButton
                iconSrc="/images/icons/currency-exchange.svg"
                altText="exchange"
                label="ตั้งค่า อัตราแลกเปลี่ยน"
                :to="{ name: 'Company.Settings.Exchange' }"
                :isDisabled="selectedCompany.isDemo"
                labelFontSize="13px"
              />

              <SettingButton
                v-if="isDevOrEngineer"
                iconSrc="/images/icons/currency-exchange-repairer.svg"
                altText="exchangeRepair"
                label="ช่อมอัตราแลกเปลี่ยน"
                :to="{ name: 'Company.Settings.ExchangeRepair' }"
                :isDisabled="selectedCompany.isDemo"
                labelFontSize="13px"
              />
            </template>

            <!-- ==================== TOPSERV ==================== -->

            <SettingButton
              v-if="product.isTopserv"
              iconSrc="/images/icons/icon-setting-add-branch.svg"
              altText="branch"
              label="จัดการสาขา"
              :to="{ name: 'Company.Settings.Branch' }"
              :isDisabled="selectedCompany.isDemo"
            />

            <!-- ==================== ADMIN ONLY ==================== -->

            <template v-if="role.admin">

              <v-btn
                class="ma-3 btn-border"
                color="white"
                width="190px"
                height="190px"
                link
                :to="{ name: 'Company.Settings.API' }"
                v-if="!product.isNsThaiSmartTax && !product.isFixedAssetCount"
              >
                <span>
                  <img src="/images/icons/currency-exchange-repairer.svg" class="image-style" />
                  <div class="mt-2">API</div>
                </span>
              </v-btn>

              <v-btn
                v-if="showDeleteMenu"
                class="ma-3 btn-border"
                color="white"
                width="190px"
                height="190px"
                link
                :to="{ name: 'Company.AccountsPayableDelete' }"
              >
                <span>
                  <img src="/images/icons/icon-setting-delete.svg" class="image-style" />
                  <div class="mt-2">ลบเอกสาร</div>
                </span>
              </v-btn>

            </template>

            <!-- ==================== DEV ONLY ==================== -->

            <template v-if="isDevOrEngineer">
              <v-btn
                class="ma-3 btn-border"
                color="white"
                width="190px"
                height="190px"
                link
                :to="{ name: 'Company.Settings.Products' }"
              >
                <span>
                  <img src="/images/customer-service.png" class="image-style" />
                  <div class="mt-2">จัดการผลิตภัณฑ์</div>
                </span>
              </v-btn>

              <SettingButton
                iconSrc="/images/icons/icon-setting-dup.svg"
                altText="create-duplicate-company"
                label="สร้างสำเนาบริษัท"
                :to="{ name: 'Company.Settings.CreateDuplicateCompany' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <SettingButton
                iconSrc="/images/icons/icon-setting-packages.svg"
                altText="plan-management"
                label="จัดการแพ็คเกจ"
                :to="{ name: 'Company.Settings.PlanManagement' }"
              />
            </template>

            <!-- Lao eTax configuration, read-only. Engineers only — narrower
                 than the isDevOrEngineer block above, because the page lists
                 which customers file to the live MoF gateway. Shown only for a
                 company that actually has the product. -->
            <SettingButton
              v-if="product.isLaoTaxRis && role.engineer"
              iconSrc="/images/icons/lao_tax.jpg"
              altText="lao-etax"
              label="ตั้งค่า Lao eTax"
              :to="{ name: 'Company.Settings.LaoEtax' }"
            />

            
            <SettingButton
              v-if="role.owner || role.admin || isDevOrEngineer"
              iconSrc="/images/NewCalendar.png"
              altText="generateTimePeriods"
              label="เพิ่มปีบัญชี"
              :to="{ name: 'Company.Settings.AddAccountingYear' }"
              :isDisabled="selectedCompany.isDemo"
            />

          </v-col>
        </v-row>
      </v-container>

      <!-- ==================== LOADING ==================== -->
      <v-container fluid v-else>
        <v-row align="center">
          <v-col v-for="n in 4" :key="n" cols="auto">
            <v-skeleton-loader
              class="mx-auto"
              height="190px"
              width="190px"
              type="card"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>

    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import SettingButton from "@/components/admin/settings/button-setting.vue";
import { mapState } from "vuex";
import getRole from "@/libs/getRole";

export default {
  name: "Settings",

  data() {
    return {
      showDeleteMenu: false,
      keySequence: "",
      keyResetTimeout: null
    };
  },

  components: {
    Admin,
    SettingButton
  },

  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      user: (state) => state.user.userData,
      userCompany: (state) => state.user.userCompany,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading
    }),

    // ---- ROLE NORMALIZATION (Safe) ----
    role() {
      const userCompany = this.userCompany || {};

      return {
        owner: this.checkRole(userCompany) === "owner" && !userCompany?.isDeveloper,
        developer: this.checkRole(userCompany) === "developer",
        engineer: this.user?.isEngineer,
        admin: userCompany?.isAdmin,
        user: this.checkRole(userCompany) === "user"
      };
    },

    // Developer or Engineer
    isDevOrEngineer() {
      return this.role.developer || this.role.engineer;
    },

    // ---- PRODUCT FLAG NORMALIZATION (Safe) ----
    product() {
      // fallback to empty object
      return this.selectedCompanyProductList || {};
    },

    // No product enabled
    //
    // Every product flag has to be listed here, because showEtaxMenus treats
    // "nothing enabled" as a reason to show the Thai e-Tax menus — a company
    // still being set up gets the usual set rather than an empty page. A flag
    // left out of this list therefore does the opposite of what it looks like:
    // it makes its own product read as "no product", and the Thai menus appear
    // for a customer who does not have Thai e-Tax. isLaoTaxRis was missing, so
    // a Lao-only company was offered KBank, หนังสือรับรอง, อีเมล and the rest.
    hasNoProductEnabled() {
      const p = this.product;

      return (
        !p.isEtax &&
        !p.isLaoTaxRis &&
        !p.isPdfDoc &&
        !p.isApAutomate &&
        !p.isNsThaiSmartTax &&
        !p.isFixedAssetCount &&
        !p.isExchangeRate &&
        !p.isTopserv &&
        !p.isLab &&
        !p.isNsThaiSmartTaxAverage
      );
    },

    // Etax menus shown when ETAX enabled OR no product
    showEtaxMenus() {
      return this.product.isEtax || this.hasNoProductEnabled;
    }
  },

  created() {
    this.getCompanyProductList();

    const companyID = this.$route.params.companyId;
    if (companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyID });
    }
  },

  mounted() {
    window.addEventListener("keydown", this.handleKeyPress);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyPress);
  },

  methods: {
    // ---- SECRET DELETE MENU TRIGGER (Safe) ----
    handleKeyPress(event) {
      if (event.key >= "0" && event.key <= "9") {
        this.keySequence += event.key;

        // detect "555"
        if (this.keySequence.includes("555")) {
          this.showDeleteMenu = true;
          this.keySequence = "";
        }

        // prevent infinite length
        if (this.keySequence.length > 10) {
          this.keySequence = "";
        }

        // reset after 2 seconds of inactivity
        clearTimeout(this.keyResetTimeout);
        this.keyResetTimeout = setTimeout(() => {
          this.keySequence = "";
        }, 2000);
      }
    },

    // ---- API: Fetch product list ----
    getCompanyProductList() {
      const companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },

    // ---- Role checking (ใช้ logic เดิม 100%) ----
    checkRole(userCompany) {
      return getRole(userCompany);
    }
  }
};
</script>

<style lang="scss">
#setting {
  .btn-border {
    border-radius: 20px !important;
  }

  .image-style {
    display: block;
    margin: auto;
    max-width: 60px;
    max-height: 60px;
  }

  .mt-2 {
    font-size: 16px;
    text-align: center; /* Ensure the text is centered */
    display: block; /* Ensure proper alignment */
  }
}

.custom-skeleton {
  border-radius: 16px; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
}
</style>
